export default __webpack_public_path__ + "static/media/mongolfiera.131506ed.png";